var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"up-fail"},[_c('input',_vm._g({attrs:{"type":"file","name":"file","accept":"image/png, image/jpg, image/jpeg"}},_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }